import { render, staticRenderFns } from "./site-closure-banner.vue?vue&type=template&id=f2e2b956&scoped=true"
import script from "./site-closure-banner.vue?vue&type=script&lang=js"
export * from "./site-closure-banner.vue?vue&type=script&lang=js"
import style0 from "./site-closure-banner.vue?vue&type=style&index=0&id=f2e2b956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e2b956",
  null
  
)

export default component.exports